import { useRef } from 'react';
import { Button, Modal } from '@nexply/ui';
import { QRCode } from './QRCode.js';

export interface QRModalProps {
  open: boolean;
  onClose: () => void;
  value: string;
  title?: string;
  downloadName?: string;
}

export function QRModal({ open, onClose, value, title = 'QR-Code', downloadName = 'nexply-qr.png' }: QRModalProps) {
  const wrapRef = useRef<HTMLDivElement>(null);

  function download() {
    const canvas = wrapRef.current?.querySelector('canvas');
    if (!canvas) return;
    const url = canvas.toDataURL('image/png');
    const a = document.createElement('a');
    a.href = url;
    a.download = downloadName;
    a.click();
  }

  return (
    <Modal open={open} onClose={onClose} title={title} size="sm">
      <div className="space-y-4 text-center">
        <div className="text-xs text-text-muted break-all">{value}</div>
        <div ref={wrapRef} className="flex justify-center">
          <QRCode value={value} size={240} />
        </div>
        <div className="flex justify-center gap-2 pt-2 border-t border-line">
          <Button variant="ghost" onClick={onClose}>Schließen</Button>
          <Button onClick={download}>PNG herunterladen</Button>
        </div>
      </div>
    </Modal>
  );
}
